// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 144 ? "fa3de7d5" : chunkId) + "." + {"144":"5a94a46656d07a00","375":"f89452bab04f5878"}[chunkId] + ".js";
};